module.exports = __webpack_public_path__ + "static/media/216.a627fbf7.wav";